<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.maturity="{ item }">
      {{ formatDate(item.maturity) }}
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.unitaryPrice="{ item }">
      {{ formatCurrency(item.unitaryPrice) }}
    </template>

    <template v-slot:item.yield="{ item }">
      {{ formatPercentage(item.yield) }}
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatCurrency(item.value) }}
      </span>
    </template>

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import {
  formatCurrency,
  formatDate,
  formatNumber,
  formatPercentage,
} from '@/utils/format-utils';

export default {
  name: 'HoldingBondsTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        value: 'name',
        text: 'Título',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'maturity',
        text: 'Vencimento',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'unitaryPrice',
        text: 'PU de Mercado',
        align: 'end',
      },

      {
        value: 'yield',
        text: 'Taxa',
        align: 'end',
      },

      {
        value: 'value',
        text: 'Valor de Mercado',
        align: 'end',
      },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatCurrency,
    formatDate,
    formatNumber,
    formatPercentage,
    formatPerformance: (val) => formatPercentage(val, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }),
  },
};
</script>
